<template>
  <div class="container my-1">
    <div :v-if="mensagemSucesso" v-for="i in mensagemSucesso" :key="i">
      <p>
        <b-alert show variant="success" dismissible>{{ i }}</b-alert>
      </p>
    </div>
    <div :v-if="mensagemErro" v-for="i in mensagemErro" :key="i">
      <p>
        <b-alert show variant="danger" dismissible>
          <b-icon variant="danger" icon="x-circle-fill" />
          {{ i.mensInicio }}
          <a v-if="i.mensLink != ''" :href="i.mensLink" target="_blank">aqui</a>
          {{ i.mensFim }}
        </b-alert>
      </p>
    </div>
    <div v-if="mostrarMensagemDebitosInexistentes" class="pb-1">
      <p>
        <b-alert show style="background-color: rgb(163, 207, 222)" dismissible>
          <b-icon variant="warning" icon="exclamation-diamond-fill" />
          Não existe(m) débito(s) para esta pesquisa. Solicite a CND (certidão negativa de
          débitos) clicando
          <a href="http://cndonline.siatu.pbh.gov.br/CNDOnline" target="_blank">aqui</a>.
        </b-alert>
      </p>
    </div>
    <p></p>
    <div>
      <div style="text-align: center">
        <loading :active.sync="carregando" :is-full-page="true"></loading>
      </div>
      <div class="mt-0">
        <!-- ABA DADOS GERAIS -->
        <form @submit.prevent>
          <h2 class="title">Gerar DRAM de ITBI por TRANSAÇÃO</h2>

          <b-row class="ml-1" v-if="origemAcesso !== 'AD' && origemAcesso !== 'GovBr'">
            <p>
              <b-alert show style="background-color: rgb(163, 207, 222)" dismissible>
                <b>ATENÇÃO</b>
                <br />
                - Caso já tenha realizado a declaração de ITBI e tenha perdido o número da
                transação, clique em 'Acesso identificado' para emitir o DRAM. <br />
                - Para obter o número da transação é preciso realizar a declaração de
                ITBI. Caso não tenha feito clique
                <a href="https://decort.pbh.gov.br/atendimento-eletronico-govbr/#/" target="_blank">aqui</a>
              </b-alert>
            </p>
          </b-row>

          <b-card>

            <span class="title h5" v-b-tooltip.hover="{ variant: 'primary', placement: 'right' }"
              title="Emitir DRAM de ITBI para uma transação específica.">
              Dados do DRAM
              <b-icon variant="primary" icon="info-circle-fill" class="ml-2" />
            </span>
            <b-row class="mb-4"> </b-row>
            <b-row class="mb-0">
              <b-col sm="2" md="2"> </b-col>
              <b-col sm="2" md="2" lg="1" align-self="center">
                <label for="cpf" class="pb-3 required">CPF/CNPJ</label>
              </b-col>
              <b-col sm="8" md="4" align-self="start">
                <b-form-input id="cpfCnpj" class="ml-3" type="search" @keydown="iniciaIdentificador()"
                  @keyup="limpaMensIdentificador()" :disabled="origemAcesso === 'GovBr'"
                  v-mask="['###.###.###-##', '##.###.###/####-##']" v-model="dadosContribuinte.cadastroNacional"
                  placeholder="CPF / CNPJ do adquirente principal">
                </b-form-input>
                <small id="cpfCnpj" :class="erroValidacaoCPFCNPJ" class="ml-3 form-text">
                  {{ mensagemValidacaoCPFCNPJ }}
                </small>
              </b-col>
            </b-row>

            <b-row class="mb-2 mt-3">
              <b-col sm="2" md="2"> </b-col>
              <b-col sm="2" md="2" lg="1" align-self="center">
                <label for="cpf" class="pb-3 required">Transação</label>
              </b-col>
              <b-col sm="8" md="4" align-self="start">
                <b-input-group class="mt-0 mb-0 ml-3">
                  <b-form-input id="identificador" type="search" @keyup="preencheIdentificador()" v-model="identificador"
                    @keydown="validacaoIdentificador()" :placeholder="placeHolderIdentificador">
                  </b-form-input>
                </b-input-group>
                <small id="identificador" class="form-text ml-3" :class="erroValidacaoIdentificador">
                  {{ mensagemValidacaoIdentificador }}
                </small>
              </b-col>
            </b-row>
            <b-row class="mb-2 mt-3">
              <b-col sm="2" md="2"> </b-col>
              <b-col>
                <small class="required"> preenchimento obrigatório </small>
              </b-col>
            </b-row>

            <b-row class="mr-2 float-right">
              <b-button variant="secondary" class="float-right" @click="() => limparCampos()">
                Limpar
              </b-button>
              <div v-if="exibeBtnPesquisar">
                <b-button variant="primary" class="ml-3 mr-3 float-right" :disabled="verificaPreenchimento()"
                  @click.prevent="() => pesquisar()">
                  Pesquisar
                </b-button>
              </div>
              <div v-else>
                <b-button variant="success" class="ml-3 mr-3 float-right" :disabled="verificaPreenchimento()"
                  @click.prevent="() => emitirDram(informacaoContribuinte)">
                  Emitir DRAM
                </b-button>
              </div>
            </b-row>
          </b-card>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import constantes from "../constants/index";
import validarCNPJ from "../validations";
import validarCPF from "../validations";
import router from "../routes";
import normalizaMensagemApi from "../helpers/normalizaMensagemApi";

export default {
  components: {
    loading,
  },
  directives: {
    mask,
  },
  data() {
    return {
      exibeBtnPesquisar: true,
      carregando: false,
      identificador: "",
      cnpjsRelacionados: [],
      origemAcesso: "",
      userName: "",
      origemNome: "",
      mensagemSucesso: [],
      mensagemErro: [],
      mostrarMensagemDebitosInexistentes: false,
      erroValidacaoIdentificador: "",
      mensagemValidacaoIdentificador: "",
      mensagemValidacaoCPFCNPJ: "",
      erroValidacaoCPFCNPJ: "",
      placeHolderIdentificador: "Informe a transação / ano",
      habilitaBtnPesquisar: false,

      dadosContribuinte: {
        cadastroNacional: "",
        cpf: "",
        nomeContribuinte: "",
        cnpj: "",
        tipoIdentificador: 0,
        identificador: "",
        numeroParcelamento: "",
        placaVeiculo: "",
        codigoLancamento: "",
        processoJudicial: "",
        transacao: "",
      },

      informacaoContribuinte: {
        cadastroNacional: "",
        nome: "",
        idPessoa: null,
        idPessoaPapel: null,
        idParcelamento: null,
        codigoLancamento: "",
        placaVeiculo: "",
        processoJudicial: "",
        transacao: "",
        usuario: "",
      },

      mensagem: {},

      preencheCpfCnpjOK: false,
      preencheIdentificadorOK: false,

      informacaoDram: {
        idDram: "",
      },

      tokens: {
        L: {
          pattern: /[A-Za-z ]/,
          transform: function (v) {
            return v.toLocaleUpperCase();
          },
        },
      },
    };
  },
  methods: {
    limpaMensIdentificador: function () {
      this.validacaoCPFCNPJ();
      this.mensagemValidacaoIdentificador = "";
      this.exibeBtnPesquisar = true;
    },

    focusInput: function (campo) {
      document.getElementById(campo).focus();
    },

    verificaIdentificador: function (identificador) {
      identificador = identificador.replace(/[^\d]+/g, "");
      let encontrou = false;
      if (this.origemAcesso === "GovBr") {
        let retorno = this.cnpjsRelacionados.indexOf(identificador); // procura por identificador na lista
        encontrou = retorno >= 0;
      } else {
        encontrou = true;
      }
      return encontrou;
    },

    verificaPreenchimento() {
      let opc = false;
      opc = this.dadosContribuinte.cadastroNacional !== "" &&
             this.identificador !== "" && 
             this.preencheIdentificadorOK && this.preencheCpfCnpjOK;
      return !opc;
    },

    limparCampos: function () {
      this.mensagemErro = [];
      this.mensagemSucesso = [];
      this.exibeBtnPesquisar = true;
      this.habilitaBtnPesquisar = false;
      this.mensagemValidacaoIdentificador = "";
      this.mensagemValidacaoCPFCNPJ = "";
      if (this.origemAcesso != "GovBr") {
        this.dadosContribuinte.cadastroNacional = "";
      }
      this.dadosContribuinte.identificador = "";
      this.identificador = "";
      this.erroValidacaoCPFCNPJ = "";
      this.habilitaBtnPesquisar = false;
      if (this.origemAcesso === "GovBr") {
        this.focusInput("identificador");
      } else {
        this.focusInput("cpfCnpj");
      }
    },

    pesquisar: async function () {
      this.mensagemErro = [];
      this.mensagemSucesso = [];
      if (this.verificaIdentificador(this.dadosContribuinte.cadastroNacional)) {
        if (this.dadosContribuinte.cadastroNacional != "")
          this.dadosContribuinte.cadastroNacional = this.dadosContribuinte.cadastroNacional.replace(
            /[^\d]+/g,
            ""
          );
        this.mensagemErro = [];
        this.mensagemSucesso = [];

        // TRANSACAO
        this.dadosContribuinte.tipoIdentificador = 16;
        this.dadosContribuinte.identificador = this.identificador.replace(
          /[^\d| |\w]+/g,
          ""
        );

        this.dadosContribuinte.transacao = this.identificador.replace(
          /[^\d| |\w]+/g,
          ""
        );

        await this.$axios
          .post(this.$env.url_backend + constantes.buscarContribuinte, {
            dadosContribuinte: this.dadosContribuinte,
          })
          .then((response) => {
            const retorno = response.data;
            this.informacaoContribuinte = retorno[0];
            if (this.informacaoContribuinte.MENSAGEM_RETORNO === "OK") {
              this.mensagemErro = [];
              this.mostrarDemaisInformacoes = true;

              this.informacaoContribuinte.nome = this.informacaoContribuinte.NOME;
              this.dadosContribuinte.nomeContribuinte = this.informacaoContribuinte.NOME;
              this.informacaoContribuinte.cadastroNacional = this.informacaoContribuinte.CODIGO_NACIONAL;
              this.informacaoContribuinte.idPessoa = this.informacaoContribuinte.ID_PESSOA;
              this.informacaoContribuinte.idPessoaPapel = this.informacaoContribuinte.ID_PESSOA_PAPEL;
              this.informacaoContribuinte.idParcelamento = this.informacaoContribuinte.ID_PARCELAMENTO;
              this.informacaoContribuinte.codigoLancamento = this.dadosContribuinte.codigoLancamento;
              if (this.dadosContribuinte.placaVeiculo === "") {
                this.informacaoContribuinte.placaVeiculo = null;
              } else {
                this.informacaoContribuinte.placaVeiculo = this.dadosContribuinte.placaVeiculo.replace(
                  /[^\d| |\w]+/g,
                  ""
                );
              }
              if (this.dadosContribuinte.processoJudicial === "") {
                this.informacaoContribuinte.processoJudicial = null;
              } else {
                this.informacaoContribuinte.processoJudicial = this.dadosContribuinte.processoJudicial.replace(
                  /[^\d| |\w]+/g,
                  ""
                );
              }

              if (this.dadosContribuinte.transacao === "") {
                this.informacaoContribuinte.transacao = null;
              } else {
                let numero = this.dadosContribuinte.transacao.substring(
                  0,
                  this.dadosContribuinte.transacao.length - 4
                );
                let length = 7 - numero.toString().length + 1;
                numero = Array(length).join("0") + numero;
                let ano = this.dadosContribuinte.transacao.substring(
                  this.dadosContribuinte.transacao.length - 4
                );
                this.informacaoContribuinte.transacao = numero + "/" + ano;
              }
            } else {
              this.mensagem = this.verificaLinkMens(
                this.informacaoContribuinte.MENSAGEM_RETORNO
              );
              this.limparCampos();

              this.mensagemErro.push(
                this.mensagem
              );
              this.carregando = false;
            }
            this.exibeBtnPesquisar = false;
          })
          .catch((err) => {
            this.carregando = false;
            this.limparCampos();
            const mensagem = normalizaMensagemApi(err);
            this.mensagemErro.push({
              mensInicio: mensagem,
              mensLink: "",
              mensFim: "",
            });
            window.scrollTo(0, 0);
          });
      } else {
        this.limparCampos();
        this.mensagemErro.push(
          {
            mensInicio: "A transação não pertence ao CPF/CNPJ informado.",
            mensLink: "",
            mensFim: "",
          }
        );
        this.carregando = false;
        window.scrollTo(0, 0);
      }
    },

    validacaoCPFCNPJ: function () {
      let tamCampo = 0;
      let txt = "";
      let formato = "";
      let tipo = this.dadosContribuinte.cadastroNacional.length;

      this.preencheCpfCnpjOK = false;

      //CPF
      if (tipo <= 14) {
        tamCampo = 14;
        txt = "CPF";
      } else {
        //CNPJ
        tamCampo = 18;
        txt = "CNPJ";
      }

      if (this.dadosContribuinte.cadastroNacional.length <= tamCampo) {
        this.mensagemValidacaoCPFCNPJ = txt + " digitado está incompleto";
        formato = "text-danger";
        this.preencheCpfCnpjOK = false;
      }
      if (tipo == 14) {
        if (validarCPF(this.dadosContribuinte.cadastroNacional)) {
          this.mensagemValidacaoCPFCNPJ = txt + " digitado é válido";
          formato = "text-success";
          this.preencheCpfCnpjOK = true;
        } else {
          this.mensagemValidacaoCPFCNPJ =
            txt + " - dígito verificador inválido";
          formato = "text-danger";
          this.preencheCpfCnpjOK = false;
        }
      }
      // cnpj
      else if (tipo == 18) {
        if (validarCNPJ(this.dadosContribuinte.cadastroNacional)) {
          this.mensagemValidacaoCPFCNPJ = txt + " digitado é válido";
          formato = "text-success";
          this.preencheCpfCnpjOK = true;
        } else {
          this.mensagemValidacaoCPFCNPJ =
            txt + " - dígito verificador inválido";
          formato = "text-danger";
          this.preencheCpfCnpjOK = false;
        }
      }
      this.erroValidacaoCPFCNPJ = formato;

      if (this.dadosContribuinte.identificador === "") {
        this.mensagemValidacaoIdentificador = "";
      }
      if (this.dadosContribuinte.cadastroNacional === "") {
        this.mensagemValidacaoCPFCNPJ = "";
      }
    },

    downloadArquivo: async function (pathurl) {
      window.open(pathurl)

    },

    emitirDram: async function (informacaoContribuinte) {
      this.mensagemErro = [];
      this.mensagemSucesso = [];
      this.carregando = true;
      this.informacaoContribuinte.usuario = this.origemAcesso;
      informacaoContribuinte.idPessoa = informacaoContribuinte.idPessoa || null;
      await this.$axios
        .post(this.$env.url_backend + constantes.retornaGuiaDramITBI, {
          informacaoContribuinte: informacaoContribuinte,          
        })
        .then((response) => {
          const retorno = response.data;
          if (retorno[0].IDGUIA !== null) {
            const url = retorno[0].URLEMISSAO;
            this.mensagemSucesso.push("DRAM gerado com sucesso.");
            this.downloadArquivo(url, "emissaoDRAM");
            this.carregando = false;
          } else {
            this.mensagemErro.push({
              mensInicio: retorno[0].DESCRICAO,
              mensLink: "",
              mensFim: "",
            });
          }
          this.carregando = false;

          this.exibeBtnPesquisar = true;
        })
        .catch((err) => {
          this.carregando = false;
          window.scrollTo(0, 0);
          const mensagem = normalizaMensagemApi(err);
          this.mensagemParcelamento.push(mensagem);
        });
    },

    formataParcelamentoTransacao: function (valor) {
      valor = valor + "";
      valor = parseInt(valor.replace(/[\D]+/g, ""));
      valor = valor + "";
      if (valor.length > 4) {
        valor = valor.replace(/([0-9]{4})$/g, "/$1");
      }
      if (valor == "NaN") {
        valor = "";
      }
      return valor;
    },

    iniciaIdentificador: function () {
      //  this.identificador = "";
      this.mensagemErro = [];
      this.mensagemSucesso = [];
    },

    preencheIdentificador: function () {
      let tam = 0;
      let mensErro = "";
      let textColor = "";
      let opcao = "";
      this.exibeBtnPesquisar = true;
      this.mensagemValidacaoIdentificador = "";

      if (this.identificador.length > 0) {
        //TRANSAÇAO
        tam = 5;
        opcao = "TRANSAÇÃO";
        if (this.identificador != "") {
          this.identificador = this.formataParcelamentoTransacao(this.identificador);
        }

        mensErro =
          this.identificador.length >= tam
            ? opcao + " digitada é válida"
            : opcao + " digitada está incompleta";

        textColor = this.identificador.length >= tam ? "text-success" : "text-danger";

        this.preencheIdentificadorOK =
          this.identificador.length >= tam;

        this.erroValidacaoIdentificador = textColor;
        this.mensagemValidacaoIdentificador = mensErro;
      }
      if (this.identificador === "") {
        this.mensagemValidacaoIdentificador = "";
      }
      if (this.cadastroNacional === "") {
        this.mensagemValidacaoCPFCNPJ = "";
      }
    },

    buscarCNPJSRelacionados: async function () {
      this.carregando = true;
      await this.$axios
        .get(
          `${this.$env.url_backend}${constantes.buscarCNPJRelacionados}?cpf=${this.$store.getters.userInfo.preferred_username}`
        )
        .then((response) => {
          response.data.cnpjRelacionados.listaEstabelecimento.map((estabelecimento) => {
            this.cnpjsRelacionados.push(estabelecimento.cnpj);
          });
          this.carregando = false;
          this.cnpjsRelacionados.push(this.userName);
        })
        .catch(() => {
          this.carregando = false;
        });
    },

    validacaoIdentificador: function () {
      // TRANSACAO
      this.mascaraIdentificador = {
        mask: "#######/####",
        tokens: this.tokens,
      };
    },

    verificaLinkMens: function (valor) {
      let mensagem = {
        mensInicio: "",
        mensLink: "",
        mensFim: "",
      };
      if (valor.indexOf("www") >= 0 || valor.indexOf("http") >= 0) {
        let posicaoInicialPreLink = 0;
        posicaoInicialPreLink = valor.indexOf("www"); // procura por www
        if (posicaoInicialPreLink < 0) {
          // não encontrou
          posicaoInicialPreLink = valor.indexOf("http"); // procura por http
        }
        if (posicaoInicialPreLink >= 0) {
          let valorStr = valor.substring(posicaoInicialPreLink); // retorna o substring a partir da posicaoInicialPreLink
          if (valorStr != "") {
            let palavras = valorStr.split(" "); // divide o valorStr em palavras
            mensagem.mensLink = palavras[0];
          }
        } else {
          posicaoInicialPreLink = valor.length;
        }
        mensagem.mensInicio = valor.substring(0, posicaoInicialPreLink);
        mensagem.mensFim = valor.substring(
          posicaoInicialPreLink + mensagem.mensLink.length
        );
      } else {
        mensagem.mensInicio = valor;
      }
      return mensagem;
    },
  },

  watch: {},

  computed: {},

  async beforeMount() {
    let environment = window.envJson.environment;
    if (environment === "prd") router.push({ name: "home" });

    this.userName = this.$store.getters.userInfo.preferred_username;
    this.origemAcesso = this.$store.getters.userInfo.origem;
    this.origemNome = this.$store.getters.userInfo.name;
    if (this.origemAcesso === "GovBr") {
      this.dadosContribuinte.cadastroNacional = this.userName;
      await this.buscarCNPJSRelacionados();
    }
  },

  async mounted() {
    if (this.origemAcesso === "GovBr") {
      this.focusInput("identificador");
    } else {
      this.focusInput("cpfCnpj");
    }
  },
};
</script>

<style lang="css" scoped>
.required:after {
  font-size: 18px;
  color: red;
  content: "*";
  position: absolute;
  margin-left: 5px;
}
</style>
